import { ConfirmDialog } from '@/components/ConfirmDialog';
import { getDialogMessage } from '@/shared/copy/dialogs';
import { useDisplayPreferences } from '@/shared/hooks/useDisplayPreferences';
import { DialogBody, DialogInlineCode, Text } from '@/ui';
import type { ReactElement } from 'react';

type DeleteTestDialogProps = {
  open: boolean;
  testName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteTestDialog = ({
  open,
  testName,
  loading = false,
  onClose,
  onConfirm,
}: DeleteTestDialogProps): ReactElement => {
  const { prefersMonospaceLiterals } = useDisplayPreferences();
  const resolvedTestName = testName?.trim() ?? 'this test';

  return (
    <ConfirmDialog
      open={open}
      title={getDialogMessage('entity.confirmDelete.title')}
      confirmLabel={getDialogMessage('destructive.delete.confirmLabel', { entity: 'test' })}
      confirmColor="red"
      loading={loading}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <DialogBody>
        <Text role="body" color="textSecondary">
          Are you sure you want to delete test{' '}
          <DialogInlineCode monospace={prefersMonospaceLiterals}>
            {resolvedTestName}
          </DialogInlineCode>
          ?
        </Text>
        <Text role="body" color="textSecondary">
          This action will also delete all test runs associated with this test.
        </Text>
      </DialogBody>
    </ConfirmDialog>
  );
};
